import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SiteReviewService } from '../site-review.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { DataStoreService } from '../datastore.service';
import { BehaviorSubject, firstValueFrom, forkJoin, interval } from 'rxjs';
import { IdbService } from '../idb.service';
import { FeatureFlagService } from '../../core/feature-flags/feature-flags.service';
//import { NavigationService } from '../navigation/navigation.service';

const pinncleServer = environment.serverURL;

var hostname = window.location.hostname;
var port = window.location.port;

@Injectable()
export class AuthService implements CanActivate {

  public authToken;
  public sessionId;
  public currentUser: any;
  public appEntryURL: string;
  public redictUrl;
  public signInURL;
  public database: string = "";
  idleInterval: any;

  private isAuthenticated = false; // Set this value dynamically

  private accessTokenKey = 'sr_access_token';
  private idTokenKey = 'sr_id_token';
  public expiresAtKey = 'sr_expires_at';
  private sessionIdKey = 'sr_session_id';
  private profileKey = 'sr_profile';
  // private sessionIdleTime = 60000;

  public logoUrl = new BehaviorSubject("assets/images/logo3.png");

  private webAuthConfig: any = {
    clientID: 'hYbChvXUsqiV64GfwwspR4NvRuOSWHvH',
    // clientID: '65uKZfB-CLM_boxpO2XUSz21ikMFjzcR',
    domain: 'sitereview.auth0.com',
    responseType: 'token id_token',
    //redirectUri: this.redictUrl,
    scope: 'openid profile email'
  }

  //https://console.cloud.google.com/apis/credentials/consent?project=dash-216521
  //https://console.developers.google.com/apis/credentials/oauthclient/966702354234-po6gblj1p2vnbpft7iesc2emmr2dnlf2.apps.googleusercontent.com?project=${your_project_number}


  //I have no idea where this came from.  I finally set up an entire new credential set.
  //public googleClientID_wtf: string = '966702354234-po6gblj1p2vnbpft7iesc2emmr2dnlf2.apps.googleusercontent.com';

  public googleClientID: string = '344908434643-o06i6t2l6e3gmlvvk5bfmaqced9dkuli.apps.googleusercontent.com';

  /*
  new  creds
  B_VyDDsnXKvaRHXu7fUZVm3E.
  344908434643-o06i6t2l6e3gmlvvk5bfmaqced9dkuli.apps.googleusercontent.com
  */

  public session
  public serverStatus;
  constructor(
    private router: Router,
    private siteReviewService: SiteReviewService,
    private dataStore: DataStoreService,
    private http: HttpClient,
    private idb: IdbService,
    private featureFlagService: FeatureFlagService,
    //private navigationService: NavigationService
  ) {

    if (!this.currentUser) {
      this.currentUser = JSON.parse(localStorage.getItem('curUserData'));
    }

    if (!this.session) {
      let session = localStorage.getItem('session');
      session = {...JSON.parse(session), ...this.currentUser}
      if (session != null) {
        this.session = session;
        if (!this.session.internalContactsID)
          this.session.internalContactsID = 0;

      } else {
        this.session = {};
        if (!this.session.internalContactsID)
          this.session.internalContactsID = 0;
      }
    }

    if (hostname == 'localhost' || (!environment.production && window.location.protocol === 'http:')) {
      this.redictUrl = `http://${hostname}:${port}/sessions/loading`;
      this.signInURL = `http://${hostname}:${port}/sessions/signin`;

    } else {

      this.redictUrl = 'https://' + hostname + '/sessions/loading';
      this.signInURL = 'https://' + hostname + '/sessions/signin';

    }


    this.checkUrl();

  }



  checkUrl() {
    let url = document.location.hostname;
    if (url.indexOf('beta') >= 0) {
      this.logoUrl.next("assets/images/dash_beta1.png");
    }
    if (url.indexOf('dash') >= 0) {
      this.logoUrl.next("assets/images/logo3.png");
    }
    if (url.indexOf('dev') >= 0) {
      this.logoUrl.next("assets/images/logo_dev.png");
    }
    if (url.indexOf('local') >= 0) {
      this.logoUrl.next("assets/images/logo_dev.png");
    }
  }
  public login(): void {
    //this.auth0.authorize();
  }


  public async directFromGoogle() {
    var fragmentString = location.hash.substring(1);
    if (fragmentString === '') this.router.navigateByUrl('/sessions/signin');
    // Parse query string to see if page request is coming from OAuth 2.0 server.
    var params: any = {};
    var regex = /([^&=]+)=([^&]*)/g, m;
    while (m = regex.exec(fragmentString)) {
      params[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }
    if (Object.keys(params).length > 0) {
      localStorage.setItem('expires_at', params.expires_in)
      localStorage.setItem('oauth2', JSON.stringify(params));
      if (params['state'] && params['state'] == 'dash_login') {
        const response = await fetch(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${params.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${params.access_token}`
            }
          }
        )
        let json = await response.json()
        let fullData = { access: params, identity: json }
        return fullData
      }
    }

  }

  public async handleAuthentication_new() {
    
    //console.log("Start Authentication")
    if (this.router.url.indexOf('signin') > 0) return false;
    //console.log("Begin Login")
    var retval = await this.directFromGoogle()
    //console.log("Got Auth Token", retval)
    let gg = retval.access;
    let authResult: any = {};
    authResult.expiresIn = gg.expires_in;
    authResult.access_token = gg.access_token;
    authResult.idToken = gg.id_token;
    authResult.idTokenPayload = { name: retval.identity.name }
    
    //await this.idb.clearData('jobs')
    localStorage.removeItem('chunkerRunToday');
    this.getSessionId(retval.access.id_token)
      .subscribe(async (res: any) => {
        
        // redirect if is not a Beta Tester
         let hasPermission =  this.checkUserBetaTester(res.groups);
        //added later:  if the return value is not checked and stopped, this will continue and the redirect
        //will never happen.
        if(!hasPermission) {
          this.siteReviewService.slacker(`Failed attempt to use non-production system by ${res}`);
          return;
        }

        // Set the time that the Access Token will expire at

        let dashTimeOut = environment.authenticationExpirationTimeoutMinutes * 1000;  //get it in milliseconds
        //let dashTimeOut = 60 * 1000;  //get it in milliseconds
        let expiresAt = JSON.stringify(dashTimeOut + new Date().getTime());

        //we will use our own timeout.
        //let googleTimeout = authResult.expiresIn * 1000;
        //let expiresAt = JSON.stringify(googleTimeout + new Date().getTime());

        localStorage.setItem(this.accessTokenKey, authResult.accessToken);
        localStorage.setItem(this.idTokenKey, authResult.idToken);
        localStorage.setItem(this.expiresAtKey, expiresAt);
        localStorage.setItem(this.sessionIdKey, res.sessionId);
        localStorage.setItem('userLogged', 'true');
        localStorage.setItem('lastLogin', new Date().toLocaleDateString());
        this.featureFlagService.refreshNavFlags().then(() => {
          //this.navigationService.rebuildMenu(); 
        }); 

        this.session.internalContactsID = res.internalContactsID;

        this.siteReviewService.sessionId = res.sessionId;
        localStorage.setItem("session", JSON.stringify(authResult));

        const officeAccess = await this.checkUserOfficesAccess(res.internalContactsID);

        let currentUserData = { 
          userLevel: res.userLevel, 
          groups: res.groups, 
          email: res.email, 
          districtID: res.districtID,
          internalContactsID: res.internalContactsID,
          name: retval.identity.name,
          officeAccess: officeAccess || []     
        };

        this.setCurrentUserData(currentUserData);
        this.siteReviewService.slacker("Successful Login by " + res);

        // Consumed once by AppComponent after the window.location.replace below,
        // so the release-notes popup fires on a fresh sign-in but not on F5.
        localStorage.setItem('firstLogin', 'true');
        let obj = this.dataStore.loadAllDefaults()
        forkJoin(obj).subscribe(foremen => {
          //console.log("CHECK MINUTES DIFF => ", this.checkMinutesDiff());
          let homeURL = '/reviews/jobs';

          let attemptedUrl = localStorage.getItem('attemptedUrl');
          let logoutFlag = localStorage.getItem('logoutFlag');

          if (attemptedUrl) {
            localStorage.removeItem('attemptedUrl');
            localStorage.removeItem('logoutFlag'); 
            
            //console.log("Redirecting user to attemptedUrl => ", attemptedUrl);
            window.location.replace(attemptedUrl);
          } else if (logoutFlag) {
            localStorage.removeItem('logoutFlag');
            window.location.replace(homeURL);
          } else {
            if (this.checkMinutesDiff()) {
              window.location.replace(homeURL);
            } else {
              let redir = localStorage.getItem("lastPage");
              if (!redir || redir === '/' || redir.indexOf('login') >= 0 || redir.indexOf('signin') >= 0) {
                redir = homeURL;
              }
              window.location.replace(redir); 
            }
          }

        });

      }, err => {
        location.href = '/sessions/error';
      })
  }


  checkUserOfficesAccess(internalContactsID: any): Promise<any> {
    
  
    return firstValueFrom(
      this.siteReviewService.getOfficeAccess(internalContactsID)
    ).then((res: any) => {
      //console.log('office access => ', res);
      return res || [];
    }).catch(err => {
      //console.error('Error getting office access', err);
      return [];
    });
  }

  checkUserBetaTester(userGroups) {
    let userGroup = 'Beta Tester';
    const foundUser = userGroups.find(item => item.includes(userGroup));

    //If your not on the production server, and aren't a tester, redirect to production
    //console.log('testing to see if user is allowed here')
    const host = document.location.hostname;
    if (host.indexOf('dash.pinnaclepowerservices.com') == -1) {
      //console.log('user is not on production server');
      if (!foundUser) {
        //console.log("Beta Tester user not found, redirecting...");
        alert('Sorry, you are not in the beta tester group. We will redirect you to production Dash');
        let redirUrl = 'https://dash.pinnaclepowerservices.com/sessions/signin'
        window.location.assign(redirUrl);
        return false;
      }else{
          //console.log('User is allowed to use Beta products')
       
      }
    
    }
    return true;
  }

  checkMinutesDiff() {
    let lastDateData = localStorage.getItem('lastDate');
    let minDiff = (new Date().getTime() - Number(lastDateData)) / 1000;
    minDiff /= 60;
    let minDiffRound = Math.abs(Math.round(minDiff));

    //console.log("minutes of difference => ", minDiff)

    if (minDiffRound > 30) {
      return true;
    } else {
      return false;
    }
  }


  private setCurrentUserData(userData: any) {
    //console.log("USER DATA",userData);
    localStorage.setItem('curUserData', JSON.stringify(userData));
  }

  private setSession(authResult): void {
    this.session = authResult;
    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem(this.accessTokenKey, authResult.accessToken);
    localStorage.setItem(this.idTokenKey, authResult.idToken);
    localStorage.setItem(this.expiresAtKey, expiresAt);
    localStorage.setItem(this.sessionIdKey, authResult.sessionId);
    this.siteReviewService.sessionId = authResult.sessionId;
    localStorage.setItem("session", JSON.stringify(authResult));
  }

  public logout(): void {

    //console.log('login out...')
    //get lastpage to store before the clear:
    let lastPage = localStorage.getItem('lastPage');
    
    localStorage.clear();
    //this.idb.clearData('gridState');

    localStorage.setItem('logoutFlag', 'true');
    localStorage.setItem('lastPage', lastPage);
    
    //changing to doc location so it wipes all javascript variables that may be here.
    document.location.href='/sessions/signin';
  }

  public authenticated(): boolean {
    // Check whether the current time is past the
    // Access Token's expiry time

    let expiresAt = JSON.parse(localStorage.getItem(this.expiresAtKey) || '{}');

    let curUserData = localStorage.getItem('curUserData');
    if (!curUserData)
      expiresAt = {};
    let authenticated = new Date().getTime() < expiresAt;
    //console.log('authenticated time => ', authenticated);
    if (authenticated) {
      expiresAt = new Date().getTime() + (1000 * environment.authenticationExpirationTimeoutMinutes)
      //expiresAt = new Date().getTime() + this.sessionIdleTime;
      localStorage.setItem(this.expiresAtKey, expiresAt);

    }
    return authenticated;
  }

  getSessionId(token) {
    return this.http.post(this.siteReviewService.apiServer + '/api/Session?sid=token', { token: token });
  }
  getSession(sID) {
    return this.http.get(this.siteReviewService.apiServer + '/api/session?sid=' + sID);
  }
  getServerStatus(server: string) {
    return this.http.get(server + '/api/server?sid=token');
  }
  
  getPDFServerStatus(server: string) {
    return this.http.get(server + '/api/server');
  }
  getMenu() {

  }

  refreshSessionId(sID) {
    return this.http.put(this.siteReviewService.apiServer + '/api/session/' + sID + '/renew', {});
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    
    const browserUrl = window.location.pathname;
    localStorage.setItem('lastDate', new Date().getTime().toString());
  
    if (browserUrl.indexOf('signin') >= 0 || browserUrl.indexOf('loading') >= 0) {
      return false;
    } else {
      localStorage.setItem('lastPage', browserUrl);
    }
  
    const userLogged = localStorage.getItem('userLogged');
    //console.log('[Guard] userLogged=', userLogged, 'state.url=', state.url);
    //console.log('[Guard] BEFORE set: attemptedUrl=', localStorage.getItem('attemptedUrl'), 'logoutFlag=', localStorage.getItem('logoutFlag'));
  
    if (userLogged) {
      return true;
    } else {
      if (state.url.indexOf('signin') === -1) {
        localStorage.setItem('attemptedUrl', state.url);
        localStorage.removeItem('logoutFlag');
        //console.log('[Guard] AFTER set: attemptedUrl=', localStorage.getItem('attemptedUrl'), 'logoutFlag=', localStorage.getItem('logoutFlag'));

      }
  
      this.router.navigate(['/sessions/signin']);
      return false;
    }
  }
  


}
